import { CrewScheduleGL } from "./gl/CrewScheduleGL";
import {
  setSelectedCrewDayMember,
  setSelectedCrewDayTime,
  setTimelineLink,
} from "src/redux/actions/CrewSchedule/CrewSchedule.Actions";
import { Dispatch } from "redux";
import { checkOS } from "src/utils";

export const crewScheduleAxisLimitInMilliseconds = 1.8 * 2629743000; //the duration of 2 month

export const handleWheel =
  (
    crewSchedGL: React.MutableRefObject<CrewScheduleGL>,
    mount: React.MutableRefObject<HTMLDivElement>,
    liveLoad: boolean,
    isCameraLocked: boolean,
    isAnimating: boolean,
    start: () => void,
    windowId: string,
    dispatch: Dispatch<any> | null,
    dataLoadedCheck?: (val1: number, val2: number) => void
  ) =>
  (event: React.WheelEvent): void => {
    let axisToUse = event.deltaY;
    if (checkOS() === "macOS") {
      if (event.shiftKey) {
        axisToUse = event.deltaX;
      } else {
        axisToUse = event.deltaY;
      }
    }
    if (Math.floor(axisToUse) === 0) {
      return;
    }
    const delta = axisToUse >= 1 ? 100 : -100;
    const scrollAmount = axisToUse >= 1 ? 70 : -70;
    if (event.shiftKey || event.altKey) {
      const [minTime, maxTime] = crewSchedGL.current.getTimeRange();

      const rect = mount.current.getBoundingClientRect();
      const x = (event.clientX - rect.left) * window.devicePixelRatio;

      if (delta < 0 || maxTime - minTime < crewScheduleAxisLimitInMilliseconds) {
        const timeX = minTime + crewSchedGL.current.pixelCoordsToTimeAxis(x);
        crewSchedGL.current.zoomCamera(delta);

        if (!isCameraLocked) {
          const newPixels = crewSchedGL.current.timeAxisToPixelCoords(timeX);
          crewSchedGL.current.moveCameraByXPixels(newPixels - x);
        }

        //check if you need to load more data...
        if (liveLoad && dataLoadedCheck && typeof dataLoadedCheck === "function") {
          dataLoadedCheck(minTime, maxTime);
        }

        // If dispatch is passed in, this timeline is an actively linked timeline, dispath time range.
        if (dispatch && windowId) {
          const [start, end] = crewSchedGL.current.getTimeRange();
          dispatch(setTimelineLink(start, end, windowId));
        }
      }
    } else {
      crewSchedGL.current.moveCameraByYPixels(scrollAmount);
    }

    if (!isAnimating) {
      start();
    }
  };

export const handleKeyPress =
  (crewSchedGL: React.MutableRefObject<CrewScheduleGL>, dispatch: Dispatch<any>) =>
  (event: React.KeyboardEvent): void => {
    const currentSelectedCrewDays = crewSchedGL.current?.getSelectedCrewDays();
    if (!currentSelectedCrewDays) {
      return;
    }

    switch (event.key) {
      case "ArrowUp":
      case "w":
      case "W":
        dispatch(setSelectedCrewDayMember(crewSchedGL.current.getSelectedCrewDayDeltaRow(-1, true)));
        break;
      case "ArrowDown":
      case "s":
      case "S":
        dispatch(setSelectedCrewDayMember(crewSchedGL.current.getSelectedCrewDayDeltaRow(1, true)));
        break;
      case "ArrowLeft":
      case "a":
      case "A":
        dispatch(setSelectedCrewDayTime(crewSchedGL.current.getSelectedCrewDayDeltaTime(-1, true)));
        break;
      case "ArrowRight":
      case "d":
      case "D":
        dispatch(setSelectedCrewDayTime(crewSchedGL.current.getSelectedCrewDayDeltaTime(1, true)));
        break;
      default:
        break;
    }
  };
